import { gql } from "@apollo/client";

export const GET_PACKAGES_QUERY_NAME = "GetPackagesQuery";
export const GET_PACKAGES_QUERY = gql`
  query ${GET_PACKAGES_QUERY_NAME}(
  $packages_type: RepoTUpgradePackagePackageTypeChoices
  $package_name: String
  $cursor: String
  $first: Int = 25
  ) {
  packages {
    list(package_type: $packages_type, package_name: $package_name, after: $cursor, first: $first) {
      edges {
        node {
          id_package
          package_name
          package_type
          meta
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}`;

export const CREATE_PACKAGE_FILE_MUTATION = gql`
  mutation CreatePackage($file: Upload!, $package_type: PackageTypesEnum!) {
    create_package_file(file: $file, package_type: $package_type) {
      success
      message
    }
  }
`;

export const DELETE_PACKAGE_FILE_MUTATION = gql`
  mutation DeletePackage($ids: [Int!]) {
    delete_package_file(ids: $ids) {
      success
      message
    }
  }
`;

export const GET_ASSIGNED_ACCOUNTS_TO_PACKAGE_QUERY_NAME =
  "GetAssignedAccounts";
export const GET_ASSIGNED_ACCOUNTS_TO_PACKAGE_QUERY = gql`
  query ${GET_ASSIGNED_ACCOUNTS_TO_PACKAGE_QUERY_NAME}(
    $id_package: Int!
    $cursor: String
    $first: Int = 25
    $name: String
  ) {
    packages {
      by_id(id_package: $id_package) {
        assignment {
          id_ipmp
        }
        package_name
        package_type
      }
    }
    ipmp_accounts(after: $cursor, first: $first, name__icontains: $name) {
      edges {
        node {
          name
          description
          enabled
          id_ipmp
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const ASSIGN_PACKAGE_MUTATION = gql`
  mutation AssignPackage($id_ipmp: [Int!], $id_package: [Int!]) {
    create_assign_package(id_ipmp: $id_ipmp, id_package: $id_package) {
      success
      message
    }
  }
`;

export const UNASSIGN_PACKAGE_MUTATION = gql`
  mutation UnassignPackage($id_ipmp: [Int!], $id_package: [Int!]) {
    delete_assign_package(id_ipmp: $id_ipmp, id_package: $id_package) {
      success
      message
    }
  }
`;

export const READ_OTA_HMAC_NAME = "ReadOtaHacInfo";
export const READ_OTA_HMAC_QUERY = gql`
  query ${READ_OTA_HMAC_NAME} {
    packages {
      hmac {
        aota_pkg_version
        hmac_secret_b64url
      }
    }
  }
`;

export const UPLOAD_OTA_HMAC = gql`
  mutation UploadOtaHmac($file: Upload!) {
    create_ota_hmac(file: $file) {
      success
      message
    }
  }
`;

export const UPDATE_OTA_HMAC = gql`
  mutation UpdateOtaHmac($secrets: [InputHmacSecrets]!) {
    update_ota_hmac(secrets: $secrets) {
      success
    }
  }
`;

export const DELETE_OTA_HMAC = gql`
  mutation DeleteOtaHmac {
    delete_ota_hmac {
      success
    }
  }
`;
